export default () => !!localStorage.enrollpaymentUser